import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import Breadcrumb from 'components/Common/Breadcrumb2';
import CreatePortalLink from './CreatePortalLink';
import PortalLinksTable from './PortalLinksTable';
import { addPortalLink, getPortalLinks } from 'store/actions';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const PortalLinksList = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const portalLinksData = useSelector((state) => state.PortalLinks.portalLinks);
  const loading = useSelector((state) => state.PortalLinks.loading);
  const fieldErrors = useSelector((state) => state.PortalLinks.fieldErrors);
  const refreshTrigger = useSelector((state) => state.PortalLinks.refreshTrigger);
  
  const permissions = JSON.parse(localStorage?.getItem('permissions')) || [];
  const isAdmin = Cookies.get('isAdmin') === "yes";
  
  const hasCreatePermission = isAdmin || permissions.includes('portallinks.create');
  const hasListPermission = isAdmin || permissions.includes('portallinks.list');

  useEffect(() => {
    if (!hasListPermission) {
      navigate('/pages-403');
    }
  }, [hasListPermission, navigate]);

  const handleSubmit = (data, resetForm, handleClose) => {
    dispatch(addPortalLink(data, resetForm, handleClose));
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  document.title = 'Portal Links | NCSI';

  return (
    <>
      <CreatePortalLink
        loading={loading}
        fieldErrors={fieldErrors}
        visible={isOpen}
        onSubmit={handleSubmit}
        handleClose={handleClose}
      />

      <div className="page-content container-fluid">
        <div className="d-flex justify-content-between align-items-center mx-3">
          <Breadcrumb
            title="Portal Links"
            breadcrumbItems={[
              { title: 'Dashboard', link: '/dashboard' },
              { title: 'Portal Links', link: '#' },
            ]}
          />
          {hasCreatePermission && (
            <Button
              className="bg-primary text-white d-flex justify-content-center gap-1 align-items-center"
              onClick={() => setIsOpen(true)}
            >
              <i className="ti-plus"></i> {t('Add New')}
            </Button>
          )}
        </div>

        <PortalLinksTable
          fieldErrors={fieldErrors}
          totalrows={portalLinksData?.data?.total}
          loading={loading}
          list={portalLinksData?.data?.portallinks}
          refreshTrigger={refreshTrigger}
        />
      </div>
    </>
  );
};

export default PortalLinksList;
